/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBoolean } from '../../models/api-response-boolean';

export interface UpdateBroadcastScheduled$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function updateBroadcastScheduled(http: HttpClient, rootUrl: string, params: UpdateBroadcastScheduled$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBoolean>> {
  const rb = new RequestBuilder(rootUrl, updateBroadcastScheduled.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBoolean>;
    })
  );
}

updateBroadcastScheduled.PATH = '/v1/api/ui/broadcast/scheduled/update/{reference}';
